import { Navigate } from "react-router-dom";
import { IRoute } from "./IRoute";
import { DASHBOARD_BASE, SIGN_IN } from "../resources/links";
import useUserAccount from "../hooks/stateHooks/userAccountHook";

export const PrivateRoute = (props: IRoute): JSX.Element => {
  const { getAccount, IS_ONBOARDED, IS_ACTIVATED } = useUserAccount();
  const authed = getAccount().isAuthenticated;

  const { children } = props;

  if (!authed) {
    return <Navigate to={`/auth/${SIGN_IN}`} />;
  }

  // if (IS_ACTIVATED && !IS_ONBOARDED) {
  //   return <Navigate to={`/onboarding/company`} />;
  // }

  if (authed && IS_ACTIVATED && (IS_ONBOARDED)) {
    return <Navigate to={`${DASHBOARD_BASE}/dashboard`} />;
  }

  return (
    <>
      {children}
    </>
  );
}

export default PrivateRoute;


